<template>
  <div id="preorderMessage">
	<svg width="192" height="192" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
	  <path d="M96 176C140.183 176 176 140.183 176 96C176 51.8172 140.183 16 96 16C51.8172 16 16 51.8172 16 96C16 140.183 51.8172 176 96 176Z" stroke="#FFE600" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
	  <path d="M64 120H128" stroke="#FFE600" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
	  <path d="M72 72H72.08" stroke="#FFE600" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
	  <path d="M120 72H120.08" stroke="#FFE600" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
	<div class="thead">Будет создан предзаказ!</div>
	<div class="sub" style="width: 800px">Робуксы будут зачислены на ваш аккаунт в течении 2-4х часов!</div>
	<button class="fs24 green" @click="agree">Хорошо, я согласен</button>
	<button class="fs24 red" @click="$root.restart">Назад</button>
  </div>
</template>

<script>
export default {
  props: ["data"],

  methods: {
	agree() {
	  this.$root.setState({ label: "order-confirm", data: {...this.data, preorder: true} })
	},
  }
}
</script>
